import { Avatar, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@chain-zen/ui'
import { useState } from 'react'

import type { IMembership } from '../../../../../types/user'

interface IWorkspaceListModal {
  onClose?: () => void
  onSelectWorkspace: (workspaceID: string) => void
  workspaceList: IMembership[]
  description?: string
  title?: string
}

export const WorkspaceListModal = (props: IWorkspaceListModal) => {
  const {
    workspaceList,
    onSelectWorkspace,
    onClose,
    title = 'Select a workspace',
    description = 'This user belongs to multiple workspaces. Please select one.'
  } = props

  const [openModal, setOpenModal] = useState(workspaceList.length > 0)

  const handleWorkspaceSelection = (workspaceID: string) => {
    onSelectWorkspace(workspaceID)
    setOpenModal(false)
  }

  const handleOpenChange = (open: boolean) => {
    setOpenModal(open)
    if (!open && onClose) {
      onClose()
    }
  }

  return (
    <Dialog open={openModal} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div>
          <div className="max-h-96 overflow-y-auto space-y-1">
            {workspaceList.map((membership) => (
              <div
                key={membership?.workspaceID}
                className="flex cursor-pointer items-center p-2 hover:bg-accent/50 transition rounded-md"
                onClick={() => handleWorkspaceSelection(membership?.workspaceID || '')}
              >
                <Avatar
                  alt="Workspace Avatar"
                  className="w-8 h-8 rounded-full mr-2"
                  name={membership?.workspace?.displayName || ''}
                  src={membership?.workspace?.logo || undefined}
                  variant="square"
                />
                <h3 className="text-sm font-medium">{membership?.workspace?.displayName ?? ''}</h3>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
